const timeOutCheck = 900000 // 15 minutes to count before idle prompt user. this counter doesn't start until user has been idle for 5 minutes (main.js)

function isAppIdle () {
    var lastActiveTime = new Date(localStorage.getItem('PortalAppActive')) || new Date()
    //console.log('date difference', new Date() - lastActiveTime)
    return (new Date() - lastActiveTime >= timeOutCheck)
}

export default {
    isAppIdle: isAppIdle
}
